"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedInfluence = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const Resources_1 = require("../../Resources");
class RedInfluence {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.RED_INFLUENCE;
        this.description = 'Lose 3 M€ for each set of 5 TR over 10 (max 5 sets). Increase M€ production 1 step per influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.REDS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const amount = Math.floor((player.getTerraformRating() - 10) / 5);
            if (amount > 0) {
                player.addResource(Resources_1.Resources.MEGACREDITS, amount * -3, { log: true, from: this.name });
            }
            player.addProduction(Resources_1.Resources.MEGACREDITS, turmoil.getPlayerInfluence(player), { log: true, from: this.name });
        });
    }
}
exports.RedInfluence = RedInfluence;
//# sourceMappingURL=RedInfluence.js.map